import React from "react";

const defaultContextValue = {
    index: 0,
    scrollEnabled: true,
    updateContext: (index, scrollEnabled) => { },
}

const MenuContext = React.createContext(defaultContextValue);

export default MenuContext;
